<template>
    <div class="item posr pageShadowBox">
        <router-link :to="to" class="link">
            <div class="img_box">
                <img :src="src" :alt="title">
            </div>
            <div class="row item_content">
                <div class="col-12" :class="titleClass">
                    <b :class="{ hot_tag: hot_tag }" class="new_hottag">
                        {{ hot_tag ? hot_tag : '&nbsp;' }} 
                    </b>
                </div>
                <div class="col-12" :class="dateClass">
                    <i>
                        <img :src="require(`@/assets/images/icon/time.svg`)" alt="time">
                        {{ date }}
                    </i>
                </div>
                <div class="col-12">
                    <p>
                        {{ title }}
                    </p>
                    <div class="cloak_dom">
                        <p class="justify">立即報名</p>
                    </div>
                </div>
            </div>
        </router-link>
        <a class="blot posa" @click="addCollection(product)" :class="{'active': product.Favorites}"></a>
    </div>
</template>

<script>
    import _ from 'lodash'
    import addCollectionMixin from '@/mixins/addCollection'

    export default {
        mixins: [addCollectionMixin],
        props: {
            product: {
                type: Object,
                required: true
            },
            isSingleRow: { // 如果是精選區
                type: Boolean,
                default() {
                    return false;
                }
            }
        },
        methods: {
            setWidth() {
                this.width = _.get(this.$el, 'clientWidth');
                // if(this.isSingleRow) {
                //     console.log(this.width, e)
                // }
            },
        },
        data() {
            return {
                width: 0
            };
        },
        mounted() {
            this.setWidth();
        },
        created() {
            window.addEventListener('resize', this.setWidth)
            window.addEventListener('load', this.setWidth)
        },
        destroyed() {
            window.removeEventListener('resize', this.setWidth)
            window.removeEventListener('load', this.setWidth)
        },
        computed: {
            titleClass() {
                if (this.isSingleRow) {
                    if (this.width > 373) {
                        return ['col-xl-12'];
                    }
                    if (this.width == 550) return ['col-sm-12'];
                }
                return ['col-sm-12']
            },
            dateClass() {
                if (this.isSingleRow) {
                    if (this.width > 373) {
                        return ['col-xl-12'];
                    }
                    if (this.width == 550) return ['col-sm-12'];
                }
                return ['col-sm-12']
            },
            src() {
                return _.get(this.product, 'CoverImage');
            },
            to() {
                let parentid = _.get(this.product, 'TypeID');
                let id = _.get(this.product, 'InitID');
                return {
                    name: 'products.show',
                    params: {
                        parentid,
                        id,
                    },
                };
            },
            hot_tag() {
                return _.get(this.product, 'HotSell');
            },
            date() {
                return _.get(this.product, 'ClassDate');
            },
            title() {
                return _.get(this.product, 'ClassTitle');
            },
        }
    }
</script>